<template>
  <div class="about__section">
    <h3 class="partners__title">{{ title }}</h3>
    <ul class="partners__list">
      <li v-for="(partner, partnerKey) in partners" :key="partnerKey" class="partners__item">
        <figure class="partners__image" :style="{ backgroundImage: `url(${partner.logo})` }" :title="partner.name"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Partners',
  props: {
    title: { type: String, default: null },
    partners: { type: Array, default: null }
  }
}
</script>
